import React from 'react';

export const Card = ({ children, className = '', ...props }) => {
  return (
    <div className={`bg-white rounded-2xl shadow-sm border border-padua-sage/20 overflow-hidden ${className}`} {...props}>
      {children}
    </div>
  );
};